import React, { useState, useEffect } from 'react';
import * as api from '~/Services/Service';
import Loading from '~/Components/Loading';
import { toast } from 'react-toastify';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Formik, Field } from 'formik';
import Header from '~/Components/Header/Header';
import {
  Row,
  Col,
  Button,
  Form,
  Table,
  Modal,
  Card,
  Pagination,
} from 'react-bootstrap';
import {
  FaSearch,
  FaFileSignature,
  FaFileContract,
  FaWindowClose,
  FaUserPlus,
  FaUserMinus,
  FaHistory,
  FaSortUp,
  FaSortDown,
  FaSort,
} from 'react-icons/fa';
import ModalHistoricoAtribuicao from '~/Components/DocumentoDigital/ModalHistoricoAtribuicao';
import AuthStorage from '~/Utils/AuthStorage';
import MaskedInput from 'react-text-mask';
import { MASK_CPF, caracteristicas } from '~/constant';
import { default as Selector } from 'react-select';
import { format } from '~/Utils/Helpers';
import { FiAlertTriangle } from 'react-icons/fi';
import { Check } from 'phosphor-react';

const PesquisaDocumentoDigital = () => {
  const [resultados, setResultados] = useState(null);
  const [carregando, setCarregando] = useState(false);
  const temPermissao = AuthStorage.temCaracteristica(
    caracteristicas.ManutencaoDocDigital
  );
  const temPermissaoAtribuicao = AuthStorage.temCaracteristica(
    caracteristicas.AtribuicaoAssinaturaDocDigital
  );
  const [mostrarModalAlerta, setMostrarModalAlerta] = useState(false);
  const [mostrarModalAtribuicao, setMostrarModalAtribuicao] = useState(false);
  const [itemParaAtribuir, setItemParaAtribuir] = useState(null);
  const [linhaSelecionada, setLinhaSelecionada] = useState(null);
  const [usarCard, setUsarCard] = useState(window.innerWidth <= 768);
  const [atribuindo, setAtribuindo] = useState(null);
  const [filtrosAtuais, setFiltrosAtuais] = useState(null);
  const [mostrarModalHistorico, setMostrarModalHistorico] = useState(false);
  const [itemParaHistorico, setItemParaHistorico] = useState(null);
  const [mostrarModalDesatribuicao, setMostrarModalDesatribuicao] = useState(
    false
  );
  const [itemParaDesatribuir, setItemParaDesatribuir] = useState(null);
  const [desatribuindo, setDesatribuindo] = useState(false);
  const [justificativaDesatribuicao, setJustificativaDesatribuicao] = useState(
    ''
  );
  const [colunaOrdenacao, setColunaOrdenacao] = useState(null);
  const [direcaoOrdenacao, setDirecaoOrdenacao] = useState('asc');
  const [paginaAtual, setPaginaAtual] = useState(1);
  const registrosPorPagina = 13;

  const buscarDocumentos = async filtro => {
    try {
      setCarregando(true);
      var filtroLimpo = Object.fromEntries(
        Object.entries(filtro).filter(
          ([_, value]) => value !== '' && value !== null && value !== undefined
        )
      );
      setFiltrosAtuais(filtro);
      let response = await api.pesquisarDocumentosParaAssinatura(filtroLimpo);
      setResultados(response);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setCarregando(false);
    }
  };

  const abrirLinkAssinatura = link => {
    var env = AuthStorage.getEnv();
    var baseUrl =
      env === 'prod'
        ? 'https://cliente.setpar.com.br'
        : 'https://hml-cliente.setpar.com.br';
    window.open(baseUrl + link + '&env=' + env, '_blank');
  };

  const optionsConferencia = [
    { value: '1', label: 'Não conferido' },
    { value: '2', label: 'Pendente' },
    { value: '3', label: 'Conferido' },
    { value: '4', label: 'Ajustado' },
  ];

  const optionsContratoDigital = [
    { value: '', label: 'Selecione...' },
    { value: '5', label: 'Pendente Assinaturas Clientes' },
    { value: '2', label: 'Pendente Assinaturas Testemunhas' },
    { value: '3', label: 'Pendente Assinaturas Procuradores' },
    { value: '4', label: 'Pendente Assinaturas Validadores' },
  ];

  const abrirLinkDocDigital = codigoDoc => {
    window.open('/documentodigital?codDocDigital=' + codigoDoc, '_blank');
  };

  const selecionarLinha = linha => {
    setLinhaSelecionada(linha);
  };

  const podeAssinar = (dataAssinatura, dataInicioVez) => {
    if (dataAssinatura === null && dataInicioVez === null) {
      return {
        mensagem: 'Existe um grupo anterior com pendência de assinatura.',
        cor: 'gray',
        valor: false,
      };
    } else if (dataAssinatura === null && dataInicioVez !== null) {
      return {
        mensagem: 'Realizar assinatura.',
        cor: 'green',
        valor: true,
      };
    }
    return {
      mensagem: 'Assinatura já realizada.',
      cor: 'red',
      valor: false,
    };
  };

  const informouFiltros = dados => {
    if (
      dados.codigo_pre_venda !== '' ||
      dados.cpf_cliente !== '' ||
      dados.codigo_status_documento_digital !== '' ||
      dados.tipo_doc_digital !== '' ||
      dados.codigo_venda_conferencia !== null ||
      dados.usuario_atribuido !== 0
    ) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    if (window.innerWidth <= 770) {
      setUsarCard(true);
      return;
    }
    setUsarCard(false);
  }, [window.innerWidth]);

  const abrirModalAtribuicao = item => {
    setItemParaAtribuir(item);
    setMostrarModalAtribuicao(true);
  };

  const confirmarAtribuicao = async () => {
    if (!itemParaAtribuir) return;
    try {
      setAtribuindo(true);
      await api.atribuirResponsavelDocumentoDigital(
        itemParaAtribuir.codigo_doc_digital
      );
      toast.success('Documento atribuído com sucesso!');
      setMostrarModalAtribuicao(false);
      setItemParaAtribuir(null);
      buscarDocumentos(filtrosAtuais);
    } catch (error) {
      console.error(error);
      toast.error(error.message);
    } finally {
      setAtribuindo(false);
    }
  };

  const abrirModalHistorico = item => {
    setItemParaHistorico(item);
    setMostrarModalHistorico(true);
  };

  const abrirModalDesatribuicao = item => {
    setItemParaDesatribuir(item);
    setJustificativaDesatribuicao('');
    setMostrarModalDesatribuicao(true);
  };

  const confirmarDesatribuicao = async () => {
    if (!itemParaDesatribuir) return;
    if (!justificativaDesatribuicao.trim()) {
      toast.warning('Informe a justificativa para desatribuição');
      return;
    }
    try {
      setDesatribuindo(true);
      await api.desatribuirResponsavelDocumentoDigital(
        itemParaDesatribuir.codigo_doc_digital,
        justificativaDesatribuicao
      );
      toast.success('Documento desatribuído com sucesso!');
      setMostrarModalDesatribuicao(false);
      setItemParaDesatribuir(null);
      setJustificativaDesatribuicao('');
      buscarDocumentos(filtrosAtuais);
    } catch (error) {
      console.error(error);
      toast.error(error.message);
    } finally {
      setDesatribuindo(false);
    }
  };

  var alternarOrdenacao = function(coluna) {
    if (colunaOrdenacao === coluna) {
      setDirecaoOrdenacao(direcaoOrdenacao === 'asc' ? 'desc' : 'asc');
    } else {
      setColunaOrdenacao(coluna);
      setDirecaoOrdenacao('asc');
    }
    setPaginaAtual(1);
  };

  var iconeOrdenacao = function(coluna) {
    if (colunaOrdenacao !== coluna)
      return <FaSort color="#ccc" size={12} className="ml-1" />;
    if (direcaoOrdenacao === 'asc')
      return <FaSortUp color="#333" size={12} className="ml-1" />;
    return <FaSortDown color="#333" size={12} className="ml-1" />;
  };

  var colunasData = ['data_solicitacao', 'data_assinatura'];

  var ordenarResultados = function(dados) {
    if (!colunaOrdenacao || !dados) return dados;
    var ordenados = dados.slice();
    ordenados.sort(function(a, b) {
      var valA = a[colunaOrdenacao];
      var valB = b[colunaOrdenacao];
      if (valA == null && valB == null) return 0;
      if (valA == null) return 1;
      if (valB == null) return -1;
      if (colunasData.indexOf(colunaOrdenacao) >= 0) {
        valA = new Date(valA).getTime();
        valB = new Date(valB).getTime();
      } else if (typeof valA === 'number' && typeof valB === 'number') {
      } else {
        valA = String(valA).toLowerCase();
        valB = String(valB).toLowerCase();
      }
      if (valA < valB) return direcaoOrdenacao === 'asc' ? -1 : 1;
      if (valA > valB) return direcaoOrdenacao === 'asc' ? 1 : -1;
      return 0;
    });
    return ordenados;
  };

  const resultadosOrdenados = ordenarResultados(resultados);

  const totalPaginas = resultadosOrdenados
    ? Math.ceil(resultadosOrdenados.length / registrosPorPagina)
    : 0;

  const registrosPaginados = React.useMemo(
    function() {
      if (!resultadosOrdenados) return null;
      const indiceUltimo = paginaAtual * registrosPorPagina;
      const indicePrimeiro = indiceUltimo - registrosPorPagina;
      return resultadosOrdenados.slice(indicePrimeiro, indiceUltimo);
    },
    [resultadosOrdenados, paginaAtual]
  );

  const mudarPagina = function(numeroPagina) {
    setPaginaAtual(numeroPagina);
  };

  useEffect(
    function() {
      setPaginaAtual(1);
    },
    [resultados]
  );

  return (
    <div>
      {temPermissao && (
        <>
          <Header title="Pesquisa Documento Digital" />
          <Formik
            initialValues={{
              codigo_pre_venda: '',
              cpf_cliente: '',
              codigo_status_documento_digital: '',
              tipo_doc_digital: '',
              codigo_venda_conferencia: null,
              mostrar_minhas_pendencias: false,
              usuario_atribuido: 0,
            }}
            onSubmit={filtro => {
              buscarDocumentos(filtro);
            }}
          >
            {({ handleSubmit, setFieldValue, values }) => (
              <Form
                onSubmit={handleSubmit}
                className="container-fluid bg-white p-3"
              >
                <Row>
                  <Col xs={12} sm={6} md={3} lg={2}>
                    <Form.Group controlId="codigo_pre_venda">
                      <small>Pré-venda</small>
                      <Field
                        type="text"
                        name="codigo_pre_venda"
                        className="form-control"
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={6} md={4} lg={2}>
                    <Form.Group controlId="cpf_cliente">
                      <small>CPF</small>
                      <MaskedInput
                        type="tel"
                        name="cpf_cliente"
                        className={'form-control'}
                        placeholder={'Ex.: 000.000.000-00'}
                        mask={MASK_CPF}
                        value={values.cpf_cliente}
                        onChange={e => {
                          setFieldValue('cpf_cliente', e.target.value);
                        }}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={6} md={4} lg={3}>
                    <Form.Group controlId="codigos_status_documento_digital">
                      <small>Grupo pendente</small>
                      <Selector
                        placeholder="Selecione..."
                        options={optionsContratoDigital}
                        onChange={selectedOptions => {
                          setFieldValue(
                            'codigo_status_documento_digital',
                            selectedOptions.value
                          );
                        }}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={6} md={4} lg={3}>
                    <Form.Group controlId="tipo_doc_digital">
                      <small>Tipo de documento</small>
                      <Field
                        as="select"
                        name="tipo_doc_digital"
                        className="form-control"
                      >
                        <option value="">Selecione...</option>
                        <option value="9">Autorização de Escritura</option>
                        <option value="10">
                          Autorização Transferência de Conta
                        </option>
                        <option value="11">
                          Cancelamento de Cessão de Direitos
                        </option>
                        <option value="8">
                          Cessão de Transferência de Cotas
                        </option>
                        <option value="2">CLBD</option>
                        <option value="12">Confissão de Dívida</option>
                        <option value="1">Contrato de Compra e Venda</option>
                        <option value="13">Lote de Apoio</option>
                        <option value="14">Recibo</option>
                        <option value="3">
                          Refinanciamento - Aditamento Contrato
                        </option>
                        <option value="5">Rescisão Bilateral</option>
                        <option value="4">Rescisão Repasse</option>
                        <option value="7">Rescisão Unilateral</option>
                        <option value="6">Transferência Titularidade</option>
                      </Field>
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={6} md={5} lg={2}>
                    <Form.Group controlId="codigo_venda_conferencia">
                      <small>Conferência</small>
                      <Selector
                        isMulti={true}
                        options={optionsConferencia}
                        placeholder={'Todas...'}
                        onChange={selectedOptions => {
                          setFieldValue(
                            'codigo_venda_conferencia',
                            selectedOptions
                              ? selectedOptions
                                  .map(option => option.value)
                                  .join(',')
                              : null
                          );
                        }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="justify-content-end mt-2">
                  <Col xs={12} sm={6} md={3} lg={2}>
                    <Form.Group controlId="minhas_pendencias">
                      <small>&nbsp;</small>
                      <Form.Check
                        type="checkbox"
                        label="Minhas pendências"
                        checked={values.mostrar_minhas_pendencias}
                        onChange={e => {
                          setFieldValue(
                            'mostrar_minhas_pendencias',
                            e.target.checked
                          );
                          if (e.target.checked) {
                            setFieldValue(
                              'usuario_atribuido',
                              AuthStorage.getUser().usuario
                            );
                          } else {
                            setFieldValue('usuario_atribuido', 0);
                          }
                        }}
                      />
                    </Form.Group>
                  </Col>
                  <Col
                    xs={12}
                    sm={6}
                    md={3}
                    lg={2}
                    className={`${usarCard && 'd-flex justify-content-end'}`}
                  >
                    <Form.Group controlId="btn_buscar">
                      <small>&nbsp;</small>
                      <Button
                        className="w-100"
                        variant="success"
                        type="submit"
                        title={
                          !informouFiltros(values)
                            ? 'Informe ao menos um filtro para pesquisar'
                            : ''
                        }
                        disabled={!informouFiltros(values) || carregando}
                      >
                        <FaSearch />
                        <span className="ml-1"> Buscar</span>
                      </Button>
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
          {!carregando && resultados !== null && resultados.length > 0 && (
            <div className="container-fluid bg-white">
              {!usarCard && (
                <div className="table-responsive">
                  <Table
                    className="table table-striped table-bordered table-hover"
                    style={{ fontSize: '0.85rem' }}
                  >
                    <thead>
                      <tr style={{ whiteSpace: 'nowrap' }}>
                        <th
                          style={{ cursor: 'pointer' }}
                          onClick={function() {
                            alternarOrdenacao('numero_prevenda');
                          }}
                        >
                          Pré-Venda {iconeOrdenacao('numero_prevenda')}
                        </th>
                        <th
                          style={{ cursor: 'pointer' }}
                          onClick={function() {
                            alternarOrdenacao('tipo_doc');
                          }}
                        >
                          Documento {iconeOrdenacao('tipo_doc')}
                        </th>
                        <th
                          style={{ cursor: 'pointer' }}
                          onClick={function() {
                            alternarOrdenacao('data_solicitacao');
                          }}
                        >
                          Data Solicitação {iconeOrdenacao('data_solicitacao')}
                        </th>
                        <th
                          style={{ cursor: 'pointer' }}
                          onClick={function() {
                            alternarOrdenacao('ge_cliente');
                          }}
                        >
                          GE/Conta {iconeOrdenacao('ge_cliente')}
                        </th>
                        <th
                          style={{ cursor: 'pointer' }}
                          onClick={function() {
                            alternarOrdenacao('empreendimento');
                          }}
                        >
                          Empreendimento {iconeOrdenacao('empreendimento')}
                        </th>
                        <th
                          style={{ cursor: 'pointer' }}
                          onClick={function() {
                            alternarOrdenacao('quadra');
                          }}
                        >
                          Quadra/Lote {iconeOrdenacao('quadra')}
                        </th>
                        <th
                          style={{ cursor: 'pointer' }}
                          onClick={function() {
                            alternarOrdenacao('descricao_venda_conferencia');
                          }}
                        >
                          Conferência{' '}
                          {iconeOrdenacao('descricao_venda_conferencia')}
                        </th>
                        <th
                          style={{ cursor: 'pointer' }}
                          onClick={function() {
                            alternarOrdenacao('nome_cliente');
                          }}
                        >
                          Nome Cliente {iconeOrdenacao('nome_cliente')}
                        </th>
                        <th
                          style={{ cursor: 'pointer' }}
                          onClick={function() {
                            alternarOrdenacao('nome_usuario_responsavel');
                          }}
                        >
                          Responsável{' '}
                          {iconeOrdenacao('nome_usuario_responsavel')}
                        </th>
                        <th
                          style={{ cursor: 'pointer' }}
                          onClick={function() {
                            alternarOrdenacao('grupo_pendente');
                          }}
                        >
                          Grupo Pendente {iconeOrdenacao('grupo_pendente')}
                        </th>
                        <th></th>
                        {temPermissaoAtribuicao && <th></th>}
                        {temPermissaoAtribuicao && <th></th>}
                      </tr>
                    </thead>
                    <tbody>
                      {registrosPaginados.length > 0 &&
                        registrosPaginados.map((item, index) => (
                          <tr
                            key={index}
                            style={{
                              fontWeight:
                                linhaSelecionada === item ? 'bold' : 'normal',
                              backgroundColor:
                                linhaSelecionada === item
                                  ? '#f0f0f0'
                                  : undefined,
                              cursor: 'pointer',
                              transition: 'background-color 0.1s ease',
                            }}
                            onClick={() => {
                              selecionarLinha(item);
                            }}
                          >
                            <td
                              onClick={() => {
                                abrirLinkDocDigital(item.codigo_doc_digital);
                              }}
                              style={{ textDecoration: 'underline' }}
                            >
                              {item.numero_prevenda}
                            </td>
                            <td>{item.tipo_doc}</td>
                            <td>{format.datetime(item.data_solicitacao)}</td>
                            <td>
                              {item.ge_cliente}/{item.conta_cliente}
                            </td>
                            <td>{item.empreendimento}</td>
                            <td>
                              {item.quadra}/{item.lote}
                            </td>
                            <td>{item.descricao_venda_conferencia}</td>
                            <td>{item.nome_cliente}</td>
                            <td>
                              <div className="d-flex align-items-center gap-1">
                                {item.nome_usuario_responsavel ? (
                                  <span
                                    className="badge badge-primary px-2 py-1"
                                    style={{
                                      backgroundColor: '#17a2b8',
                                      color: 'white',
                                      fontSize: '0.85em',
                                      fontWeight: '600',
                                      borderRadius: '4px',
                                    }}
                                    title={`Atribuído em ${format.datetime(
                                      item.data_atribuicao
                                    )}`}
                                  >
                                    {item.nome_usuario_responsavel}
                                  </span>
                                ) : (
                                  <span className="text-muted">-</span>
                                )}
                              </div>
                            </td>
                            <td>{item.grupo_pendente}</td>
                            <td>
                              <div className="d-flex gap-2 justify-content-center">
                                <FaFileSignature
                                  color={
                                    podeAssinar(
                                      item.data_assinatura,
                                      item.data_inicio_vez
                                    ).cor
                                  }
                                  title={
                                    podeAssinar(
                                      item.data_assinatura,
                                      item.data_inicio_vez
                                    ).mensagem
                                  }
                                  size={18}
                                  onClick={() => {
                                    if (
                                      podeAssinar(
                                        item.data_assinatura,
                                        item.data_inicio_vez
                                      ).valor
                                    ) {
                                      setMostrarModalAlerta(true);
                                    }
                                  }}
                                />
                              </div>
                            </td>
                            {!!temPermissaoAtribuicao && (
                              <>
                                <td>
                                  {!item.data_assinatura ? (
                                    item.codigo_usuario_responsavel ==
                                    AuthStorage.getUser().usuario ? (
                                      <Button
                                        variant="outline-danger"
                                        size="sm"
                                        title="Desatribuir"
                                        disabled={desatribuindo}
                                        onClick={() =>
                                          abrirModalDesatribuicao(item)
                                        }
                                      >
                                        <FaUserMinus />
                                      </Button>
                                    ) : (
                                      <Button
                                        variant="outline-primary"
                                        size="sm"
                                        title="Atribuir a mim"
                                        disabled={atribuindo}
                                        onClick={() =>
                                          abrirModalAtribuicao(item)
                                        }
                                      >
                                        <FaUserPlus />
                                      </Button>
                                    )
                                  ) : (
                                    <span className="text-muted">
                                      Já assinado
                                    </span>
                                  )}
                                </td>
                                <td>
                                  <Button
                                    variant="link"
                                    size="sm"
                                    className="p-0 ml-1"
                                    title="Ver histórico de atribuições"
                                    onClick={e => {
                                      e.stopPropagation();
                                      selecionarLinha(item);
                                      abrirModalHistorico(item);
                                    }}
                                  >
                                    <FaSearch size={14} />
                                  </Button>
                                </td>
                              </>
                            )}
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </div>
              )}
              {usarCard &&
                registrosPaginados.length > 0 &&
                registrosPaginados.map((item, index) => (
                  <Card
                    className="px-2 mb-2 pb-2"
                    key={index}
                    style={{
                      fontWeight: linhaSelecionada === item ? 'bold' : 'normal',
                      backgroundColor:
                        linhaSelecionada === item ? '#f0f0f0' : 'white',
                    }}
                    onClick={() => {
                      setLinhaSelecionada(item);
                    }}
                  >
                    <ul className="list-unstyled d-flex flex-wrap ImobiliariaItemResumo produtividade justify-content-between text-md-left">
                      <li className="m-1">
                        <small>Solicitado em</small>
                        <strong
                          className="d-block"
                          style={{ fontSize: 'smaller' }}
                        >
                          {format.datetime(item.data_solicitacao)}
                        </strong>
                      </li>
                      <li className="m-1">
                        <small>Documento</small>
                        <strong
                          className="d-block"
                          style={{ fontSize: 'smaller' }}
                        >
                          {item.tipo_doc}
                        </strong>
                      </li>
                    </ul>
                    <ul className="list-unstyled d-flex flex-wrap ImobiliariaItemResumo produtividade justify-content-between text-md-left">
                      <li
                        className="m-1"
                        onClick={() => {
                          abrirLinkDocDigital(item.codigo_doc_digital);
                        }}
                      >
                        <small>Pré-venda</small>
                        <strong
                          className="d-block"
                          style={{
                            fontSize: '13px',
                            textDecoration: 'underline',
                          }}
                        >
                          {item.numero_prevenda}
                        </strong>
                      </li>
                      <li className="m-1">
                        <small>Pré-venda</small>
                        <strong
                          className="d-block"
                          style={{ fontSize: '13px' }}
                        >
                          {item.grupo_signatario}
                        </strong>
                      </li>
                    </ul>
                    <ul className="list-unstyled d-flex flex-wrap ImobiliariaItemResumo produtividade justify-content-between text-md-left">
                      <li className="m-1">
                        <small>Empreendimento</small>
                        <strong
                          className="d-block"
                          style={{ fontSize: '11px' }}
                        >
                          {item.empreendimento}
                        </strong>
                      </li>
                      <li className="m-1">
                        <small>QD / LT</small>
                        <strong
                          className="d-block"
                          style={{ fontSize: '13px' }}
                        >
                          {item.quadra} / {item.lote}
                        </strong>
                      </li>
                    </ul>
                    <ul className="list-unstyled d-flex flex-wrap ImobiliariaItemResumo produtividade justify-content-between text-md-left">
                      <li className="m-1">
                        <small>Signatário</small>
                        <strong
                          className="d-block"
                          style={{
                            fontSize: 'smaller',
                          }}
                        >
                          {item.nome_signatario}
                        </strong>
                      </li>
                      {item.data_assinatura && (
                        <li className="m-1">
                          <small>Assinado em</small>
                          <strong
                            className="d-block"
                            style={{ fontSize: 'smaller' }}
                          >
                            {format.datetime(item.data_assinatura)}
                          </strong>
                        </li>
                      )}
                      {podeAssinar(item.data_assinatura, item.data_inicio_vez)
                        .valor && (
                        <li className="m-1 mt-1">
                          <Button
                            className="d-flex align-items-center"
                            variant="outline-success"
                            size={'sm'}
                            onClick={() => {
                              setMostrarModalAlerta(true);
                            }}
                          >
                            <FaFileSignature size={18} />
                            <span> Assinar</span>
                          </Button>
                        </li>
                      )}
                    </ul>
                    <ul className="list-unstyled d-flex flex-wrap ImobiliariaItemResumo produtividade justify-content-between text-md-left">
                      <li className="m-1">
                        <small>Responsável</small>
                        <strong className="d-block d-flex align-items-center">
                          {item.nome_usuario_responsavel ? (
                            <span
                              className="badge px-2 py-1"
                              style={{
                                backgroundColor: '#17a2b8',
                                color: 'white',
                                fontSize: '0.85em',
                                fontWeight: '600',
                                borderRadius: '4px',
                              }}
                              title={`Atribuído em ${format.datetime(
                                item.data_atribuicao
                              )}`}
                            >
                              {item.nome_usuario_responsavel}
                            </span>
                          ) : (
                            <span className="text-muted">Não atribuído</span>
                          )}
                          {temPermissaoAtribuicao &&
                            item.codigo_usuario_responsavel && (
                              <Button
                                variant="link"
                                size="sm"
                                className="p-0 ml-1"
                                title="Ver histórico"
                                onClick={e => {
                                  e.stopPropagation();
                                  abrirModalHistorico(item);
                                }}
                              >
                                <FaHistory color="#6c757d" size={14} />
                              </Button>
                            )}
                        </strong>
                      </li>
                      {temPermissaoAtribuicao && !item.data_assinatura && (
                        <li className="m-1 mt-1">
                          {item.codigo_usuario_responsavel ==
                          AuthStorage.getUser().usuario ? (
                            <Button
                              className="d-flex align-items-center"
                              variant="outline-danger"
                              size="sm"
                              disabled={desatribuindo}
                              onClick={() => abrirModalDesatribuicao(item)}
                            >
                              <FaUserMinus size={14} />
                              <span className="ml-1">Desatribuir</span>
                            </Button>
                          ) : (
                            <Button
                              className="d-flex align-items-center"
                              variant="outline-primary"
                              size="sm"
                              disabled={atribuindo}
                              onClick={() => abrirModalAtribuicao(item)}
                            >
                              <FaUserPlus size={14} />
                              <span className="ml-1">Atribuir</span>
                            </Button>
                          )}
                        </li>
                      )}
                    </ul>
                  </Card>
                ))}
              {totalPaginas > 1 && (
                <div className="d-flex justify-content-between align-items-center mt-2 mb-2">
                  <small className="text-muted">
                    Página {paginaAtual} de {totalPaginas} (
                    {resultadosOrdenados.length} registros)
                  </small>
                  <Pagination className="mb-0">
                    <Pagination.First
                      onClick={function() {
                        mudarPagina(1);
                      }}
                      disabled={paginaAtual === 1}
                    />
                    <Pagination.Prev
                      onClick={function() {
                        mudarPagina(paginaAtual - 1);
                      }}
                      disabled={paginaAtual === 1}
                    />
                    {totalPaginas > 10 && paginaAtual > 5 && (
                      <Pagination.Ellipsis className="ellipsis" />
                    )}
                    {[]
                      .concat(
                        Array(totalPaginas)
                          .fill(0)
                          .map(function(_, i) {
                            return i;
                          })
                      )
                      .slice(
                        Math.max(0, paginaAtual - 3),
                        Math.min(totalPaginas, paginaAtual + 2)
                      )
                      .map(function(number) {
                        return (
                          <Pagination.Item
                            key={number}
                            active={paginaAtual === number + 1}
                            onClick={function() {
                              mudarPagina(number + 1);
                            }}
                          >
                            {number + 1}
                          </Pagination.Item>
                        );
                      })}
                    {totalPaginas > 10 && paginaAtual < totalPaginas - 4 && (
                      <Pagination.Ellipsis className="ellipsis" />
                    )}
                    <Pagination.Next
                      onClick={function() {
                        mudarPagina(paginaAtual + 1);
                      }}
                      disabled={paginaAtual === totalPaginas}
                    />
                    <Pagination.Last
                      onClick={function() {
                        mudarPagina(totalPaginas);
                      }}
                      disabled={paginaAtual === totalPaginas}
                    />
                  </Pagination>
                </div>
              )}
            </div>
          )}
          {mostrarModalAlerta && linhaSelecionada !== null && (
            <Modal
              show={mostrarModalAlerta}
              onHide={() => {
                setMostrarModalAlerta(false);
              }}
            >
              <Modal.Title className="text-center">
                <div className="text-center mt-2">
                  <FiAlertTriangle
                    color="#ffc107"
                    style={{ marginRight: '8px' }}
                  />
                  <span className="d-block text-warning"> Atenção!</span>
                </div>
              </Modal.Title>
              <Modal.Body>
                <p className="text-left">
                  Ao avançar no processo de assinatura, um token será enviado ao
                  signatário por e-mail. Certifique-se de que você é o
                  signatário autorizado antes de prosseguir.
                </p>
                <div className="d-flex justify-content-between">
                  <Button
                    className="d-flex align-items-center"
                    variant={'outline-secondary'}
                    onClick={() => {
                      setMostrarModalAlerta(false);
                    }}
                  >
                    <FaWindowClose />
                    <span className="ml-2">Voltar</span>
                  </Button>
                  <Button
                    className="d-flex align-items-center"
                    variant={'success'}
                    onClick={() => {
                      abrirLinkAssinatura(linhaSelecionada.link_assinatura);
                    }}
                  >
                    <FaFileContract />
                    <span className="ml-2">Continuar</span>
                  </Button>
                </div>
              </Modal.Body>
            </Modal>
          )}
          {mostrarModalAtribuicao && itemParaAtribuir !== null && (
            <Modal
              show={mostrarModalAtribuicao}
              onHide={() => {
                setMostrarModalAtribuicao(false);
                setItemParaAtribuir(null);
              }}
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  <FaUserPlus color="#007bff" style={{ marginRight: '8px' }} />
                  Confirmar Atribuição
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>
                  Você está prestes a assumir a responsabilidade pela pendência
                  de assinatura:
                </p>
                <div className="bg-light p-3 rounded mb-3">
                  <p className="mb-1">
                    <strong>Pré-venda:</strong>{' '}
                    {itemParaAtribuir.numero_prevenda}
                  </p>
                  <p className="mb-1">
                    <strong>Documento:</strong> {itemParaAtribuir.tipo_doc}
                  </p>
                  <p className="mb-1">
                    <strong>Signatário:</strong>{' '}
                    {itemParaAtribuir.nome_signatario}
                  </p>
                  <p className="mb-0">
                    <strong>Grupo:</strong> {itemParaAtribuir.grupo_signatario}
                  </p>
                </div>
                <p className="text-muted small">
                  Ao confirmar, esta pendência será vinculada a você e aparecerá
                  no filtro "Minhas pendências".
                </p>
              </Modal.Body>
              <Modal.Footer className="d-flex justify-content-between">
                <Button
                  variant="outline-secondary"
                  onClick={() => {
                    setMostrarModalAtribuicao(false);
                    setItemParaAtribuir(null);
                  }}
                  disabled={atribuindo}
                >
                  <FaWindowClose className="mr-1" />
                  Cancelar
                </Button>
                <Button
                  variant="primary"
                  onClick={confirmarAtribuicao}
                  disabled={atribuindo}
                >
                  <FaUserPlus className="mr-1" />
                  {atribuindo ? 'Atribuindo...' : 'Confirmar Atribuição'}
                </Button>
              </Modal.Footer>
            </Modal>
          )}
          {mostrarModalDesatribuicao && itemParaDesatribuir !== null && (
            <Modal
              show={mostrarModalDesatribuicao}
              onHide={() => {
                setMostrarModalDesatribuicao(false);
                setItemParaDesatribuir(null);
              }}
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  <FaUserMinus color="#dc3545" style={{ marginRight: '8px' }} />
                  Confirmar Desatribuição
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>
                  Você está prestes a remover sua responsabilidade pela
                  pendência de assinatura:
                </p>
                <div className="bg-light p-3 rounded mb-3">
                  <p className="mb-1">
                    <strong>Pré-venda:</strong>{' '}
                    {itemParaDesatribuir.numero_prevenda}
                  </p>
                  <p className="mb-1">
                    <strong>Documento:</strong> {itemParaDesatribuir.tipo_doc}
                  </p>
                  <p className="mb-1">
                    <strong>Signatário:</strong>{' '}
                    {itemParaDesatribuir.nome_signatario}
                  </p>
                  <p className="mb-0">
                    <strong>Grupo:</strong>{' '}
                    {itemParaDesatribuir.grupo_signatario}
                  </p>
                </div>
                <Form.Group className="mb-3">
                  <Form.Label>
                    <strong>Justificativa *</strong>
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Informe o motivo da desatribuição..."
                    value={justificativaDesatribuicao}
                    onChange={e =>
                      setJustificativaDesatribuicao(e.target.value)
                    }
                    maxLength={250}
                  />
                  <Form.Text className="text-muted">
                    {justificativaDesatribuicao.length}/250 caracteres
                  </Form.Text>
                </Form.Group>
                <p className="text-muted small">
                  Ao confirmar, esta pendência será removida do filtro "Minhas
                  pendências" e ficará disponível para outros usuários.
                </p>
              </Modal.Body>
              <Modal.Footer className="d-flex justify-content-between">
                <Button
                  variant="outline-secondary"
                  onClick={() => {
                    setMostrarModalDesatribuicao(false);
                    setItemParaDesatribuir(null);
                    setJustificativaDesatribuicao('');
                  }}
                  disabled={desatribuindo}
                >
                  <FaWindowClose className="mr-1" />
                  Cancelar
                </Button>
                <Button
                  variant="danger"
                  onClick={confirmarDesatribuicao}
                  disabled={desatribuindo || !justificativaDesatribuicao.trim()}
                >
                  <FaUserMinus className="mr-1" />
                  {desatribuindo
                    ? 'Desatribuindo...'
                    : 'Confirmar Desatribuição'}
                </Button>
              </Modal.Footer>
            </Modal>
          )}
          {mostrarModalHistorico && itemParaHistorico && (
            <ModalHistoricoAtribuicao
              mostrarModal={mostrarModalHistorico}
              setMostrarModal={setMostrarModalHistorico}
              codigoDocumentoDigital={itemParaHistorico.codigo_doc_digital}
              numeroPreVenda={itemParaHistorico.numero_prevenda}
            />
          )}
          {carregando && <Loading>Carregando...</Loading>}
          {!carregando && resultados !== null && resultados.length === 0 && (
            <div className="mt-2 text-center">
              <span className="d-xs-none">Nenhum resultado encontrado.</span>
            </div>
          )}
        </>
      )}
      {!temPermissao && (
        <div className="text-center">
          <label>Usuário sem permissão para acessar a tela.</label>
        </div>
      )}
    </div>
  );
};

export default PesquisaDocumentoDigital;
